import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonMode, ButtonSize, ButtonStyle, ButtonIcon, NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'common-ui-components-temp-ngx-button',
  standalone: true,
  imports: [CommonModule, NgxButtonComponent],
  templateUrl: './temp-ngx-button.component.html',
  styleUrl: './temp-ngx-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { '[class.w-100]': 'fullWidth() && mode() !== "icon-only"' },
})
export class TempNgxButtonComponent {
  fullWidth = input<boolean>(false);
  mode = input<ButtonMode>('form');
  size = input<ButtonSize>('large');
  style = input<ButtonStyle>('fill');
  brandButton = input<boolean>(false);
  destructive = input<boolean>(false);
  rightIcon = input<ButtonIcon | undefined>(undefined as unknown as ButtonIcon);
  leftIcon = input<ButtonIcon | undefined>(undefined as unknown as ButtonIcon);
  disabled = input<boolean>(false);
  isLoading = input<boolean>(false);
  classNames = input<string[]>([]);
  clickHandler = output<MouseEvent>();

  onClick(event: MouseEvent) {
    this.clickHandler.emit(event);
  }
}
